<template>
  <v-dialog
    :model-value="modelValueBack"
    @update:model-value="$emit('update:modelValueBack', $event)"
    max-width="500"
  >
    <v-card class="modal-card">
      <v-card-title class="modal-title">Detalles del Correo</v-card-title>

      <v-card-text class="modal-body">
        <div class="info-pair">
          <span class="label">Nombre:</span>
          <span
            >{{ correo?.title }} {{ correo?.name }} {{ correo?.lastname }}</span
          >
        </div>
        <div class="info-pair">
          <span class="label">Asunto:</span>
          <span>{{ correo?.subject }}</span>
        </div>
        <div class="info-pair">
          <span class="label">Respuesta:</span>
          <textarea v-model="message" name="message" id="message" rows="5">
          </textarea>
        </div>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <button class="send-btn" @click="sendMessageBackFunction">
          Enviar
        </button>
        <button
          class="close-btn"
          @click="$emit('update:modelValueBack', false)"
        >
          Cerrar
        </button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, ref, defineEmits } from "vue";
import { sendMessageBack as sendService } from "../services/message-service";
import { showInfoToast, showSuccessToast, showErrorToast } from "@/kernel/alerts";

const props = defineProps({
  modelValueBack: Boolean,
  correo: Object,
});

const emit = defineEmits(["update:modelValueBack"]);

const message = ref("");

const sendMessageBackFunction = async () => {
  try {
    if (!message.value.trim()) {
      console.error("El mensaje no puede estar vacío");
        showErrorToast("El mensaje no puede estar vacío");
      return;
    }

    showInfoToast("Enviando mensaje...");

    const payload = {
      message_id: props.correo.id,
      fullname: `${props.correo.title} ${props.correo.name} ${props.correo.lastname}`,
      message: message.value,
      email: props.correo.email,
      subject: props.correo.subject,
    };

    const response = await sendService(payload);
    if (response.status === 200) {
      showSuccessToast("Mensaje enviado correctamente");
      message.value = "";
      emit("update:modelValueBack", false); // Close the modal
      emit("mensaje-enviado");
    } else {
      console.error("Error al enviar el mensaje");
    }
  } catch (error) {
    console.error("Error al enviar el mensaje:", error);
  }
};
</script>

<style scoped>
.modal-card {
  padding: 16px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #ff9800;
  padding-bottom: 8px;
}

.modal-body {
  font-size: 0.95rem;
  color: #444;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.info-pair {
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #eee;
}

.label {
  font-weight: 600;
  color: #ff9800;
  margin-bottom: 4px;
}

.message {
  white-space: pre-wrap;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.close-btn {
  padding: 8px 18px;
  background-color: gainsboro;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #868482b0;
}

.send-btn {
  padding: 8px 18px;
  background-color: #ff9800;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-right: 16px;
}

.send-btn:hover {
  background-color: yellowgreen;
}
</style>
